import { connect } from 'react-redux';
import { State } from 'store/types';
import SwitchView from './Switch';
import { getEligibleForVariant } from 'helpers/experimentV2';
import { AB_APP_INSTALL_NUDGE } from 'constants/experiments';

const mapStateToProps = (state: State) => ({
  isEnabled: getEligibleForVariant(state, AB_APP_INSTALL_NUDGE, 'A'),
});

export default connect(mapStateToProps)(SwitchView);
